import React from "react"

/*
	Por que existe esto.

	La "1" de Hanken es un trazo angosto dentro de una caja del ancho de
	cualquier otro digito: todos avanzan 560 milesimas de eme, pero la "1"
	lleva 87 de margen izquierdo y ~175 de margen derecho, contra ~33 de la
	"8". Medido en pantalla a 120px: "1,234" deja 21px de blanco antes de la
	coma y "3,557" deja 5. Por eso la coma se ve suelta en unos numeros y
	pegada en otros.

	No se arregla con letter-spacing, que aplica parejo a todo, ni con cifras
	proporcionales: la fuente no las trae (su GSUB no tiene pnum ni tnum).
	Asi que se corrige donde se nota, acercando el separador al uno.
*/
export const numeroConComas = (valor : number) : React.ReactNode[] =>
{
	const texto = valor.toLocaleString("es-MX")
	const partes : React.ReactNode[] = []

	for(let posicion = 0; posicion < texto.length; posicion++)
	{
		const caracter = texto[posicion]

		if(caracter !== ",")
		{
			partes.push(caracter)
			continue
		}

		const clases =
		[
			texto[posicion - 1] === "1" ? "wt-sep-tras-uno" : "",
			texto[posicion + 1] === "1" ? "wt-sep-antes-uno" : ""
		]
			.filter((clase : string) => clase)
			.join(" ")

		partes.push(
			clases
				? <span key={posicion} className={clases}>{caracter}</span>
				: caracter
		)
	}

	return partes
}
